import { Color } from '../../../models/color';
import { Column } from '.';

/* istanbul ignore file */
export class Options {
    alignment?: string;
    allowedExtensions?: string[];
    arrows?: boolean;
    bold?: boolean;
    columns?: Column[];
    dateFormat?: string;
    dateSaveFormat?: string;
    displayColor?: Color;
    displayText?: string;
    endless?: boolean;
    format?: string;
    grid?: boolean;
    height?: string;
    italic?: boolean;
    maxFileSize?: number;
    multi?: boolean;
    //TODO: No references for this. Verify and remove if not needed.
    options?: any;
    readOnly?: boolean;
    size?: string;
    toggle?: boolean;
    richTextFormula?: string;
    decimalPlaces?: number;
    description?: string;
}
